export const AIRTABLE_API_KEY = 'patSMIu4CYx9BFSua.e2a1ce15ce83ab51d26b6786dfc6953ac2a15d66053f083af30bc74816417d3c';
export const AIRTABLE_BASE_ID = 'appDlTNAhbC9CEZSB';
export const AIRTABLE_TABLE_NAME = 'tbl2EKcumxl3e0EVr';